const $jBoard = window.$jBoard;

const trans = (key, data = {}) => {
  if ($jBoard.trans[key] !== undefined) {
    let text = $jBoard.trans[key];

    for (let dataKey in data) {
      text = text.replace(`:${dataKey}`, data[dataKey]);
    }

    return text;
  }

  return key;
};

export default trans;
